<h4>{{'Edit Recommendation' | translate | async}}</h4>
<div style="display: flex; align-items: center; justify-content: center;" *ngIf="loading">
  <mat-spinner diameter="48"></mat-spinner>
</div>
<form (ngSubmit)="onSubmit(form.value)" [formGroup]="form" *ngIf="!loading">
  <span class="form-field-margin" style="margin: 24px 0;">
    {{recommendation.RecommendationName}}
    &nbsp;&nbsp;&nbsp;
    <mat-form-field>
      <mat-label>{{'Action Date' | translate | async}}</mat-label>
      <input class="input-travel" matInput (click)="picker.open()" readonly [matDatepicker]="picker" placeholder="Choose a date" [formControl]="form.controls['actionDate']" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </span>

  <mat-form-field>
    <mat-select required id="severityId" [formControl]="form.controls['severityId']" >
      <mat-option [value]="r.Id" *ngFor="let r of SeverityDropDownList">{{r.Severitycategory}}</mat-option>
    </mat-select>
    <mat-label>{{'Severity' | translate | async}}</mat-label>
  </mat-form-field>
  
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'SMU/Hourmeter to Take Action' | translate | async}}</mat-label>
      <input id="smuToTakeAction" pattern="[0-9]*" [formControl]="form.controls['smuToTakeAction']" matInput placeholder="0" type="number" class="right-align" required>
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Hours Gained' | translate | async}}</mat-label>
      <input id="smuToCompleteAction" pattern="[0-9]*" [formControl]="form.controls['smuToCompleteActionBy']" matInput placeholder="0" type="number" class="right-align" required>
      <span matSuffix>&nbsp;hrs</span>
    </mat-form-field>
  </p>
  <p class="form-field-margin">
    <mat-form-field appearance="standard">
      <mat-label>{{'Labour Cost' | translate | async}}</mat-label>
      <input id="labourCost" pattern="[0-9]*" [formControl]="form.controls['labourCost']" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Parts Cost' | translate | async}}</mat-label>
      <input id="partsCost" pattern="[0-9]*" [formControl]="form.controls['partsCost']" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
    <mat-form-field appearance="standard">
      <mat-label>{{'Misc. Cost' | translate | async}}</mat-label>
      <input id="miscCost" pattern="[0-9]*" [formControl]="form.controls['miscCost']" matInput placeholder="0" type="number" class="right-align" required>
      <span matPrefix>$&nbsp;</span>
      <span matSuffix>.00</span>
    </mat-form-field>
  </p>
  <p class="full-width">
    <mat-form-field appearance="standard">
      <mat-label>{{'Comment' | translate | async}}</mat-label>
      <textarea id="comment" [formControl]="form.controls['comment']" matInput placeholder="{{'Enter any comments about why you recommend this. ' | translate | async}}"></textarea>
    </mat-form-field>
  </p>
  <div>
    <button mat-raised-button type="button" (click)="closeModal()">{{'Cancel' | translate | async}}</button>
    <!-- <button mat-raised-button color="warn" type="submit" [disabled]="!form.valid || savingForm" [class.loading]="savingForm">{{'Update Recommendation' | translate | async}}</button> -->
    <button mat-raised-button color="warn" type="submit"  [class.loading]="savingForm">{{'Update Recommendation' | translate | async}}</button>
  </div>
</form>
